import { Injectable, Inject } from '@angular/core';
import * as Immutable from "immutable";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from "../../models/responses";
import { HttpService, JsonConvert } from "../../../../shared/providers"
import { ConfDataRequest } from "../../models/requests/confDataRequest";
import { ApiResponseBuilder } from '../../providers';
import { ContactRequest } from './contactRequest';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ContactFormController {

  public url = 'fagerhult/contact/sendemail';

  constructor(
    @Inject(HttpClient) public httpClient: HttpClient,
    public jsonConvert: JsonConvert,
    public apiResponseBuilder: ApiResponseBuilder
  ) { }

  public normalizeData = map((response, index) => this.apiResponseBuilder.build(response));

  public sendEmail(request: ContactRequest): Observable<ApiResponse> {

    return this.get(this.url, request).pipe(this.normalizeData);

  }

  public get(url: string, params?: any): Observable<any> {
    return this.httpClient.get(this.createUrl(url, params)).pipe(this.extractData);
  }

  public createUrl(url: string, params?: any) {

    let queryString = `t=${new Date().getTime()}`;

    if (params) {

      let json = this.jsonConvert.stringify(params);
      // Append the json param to query string
      queryString = `json=${json}&${queryString}`;
    }


    return `${url}?${queryString}`;
  }

  public extractData = map((response: any, index) => response || {});

}